import React, { useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import { ArrowLeft, Mail, Calendar, Target, CheckCircle2, Clock, Trash2, MapPin } from 'lucide-react';
import { DreamStepsModal } from '../components/DreamStepsModal';
const userDreams = [{
  id: 1,
  title: 'Aprender inglês fluente',
  category: 'Educação',
  status: 'in_progress',
  deadline: 'Dez 2024',
  progress: 65,
  image: 'https://images.unsplash.com/photo-1546410531-bb4caa6b424d?w=400',
  steps: [{
    id: 1,
    title: 'Matricular em curso online',
    completed: true,
    completedDate: '10/01/2024'
  }, {
    id: 2,
    title: 'Estudar 30 minutos por dia',
    completed: true,
    completedDate: '15/01/2024'
  }, {
    id: 3,
    title: 'Completar módulo de gramática',
    completed: true,
    completedDate: '25/01/2024'
  }, {
    id: 4,
    title: 'Praticar conversação',
    completed: false,
    completedDate: null
  }]
}, {
  id: 2,
  title: 'Correr uma maratona',
  category: 'Saúde',
  status: 'in_progress',
  deadline: 'Jun 2024',
  progress: 40,
  image: 'https://images.unsplash.com/photo-1452626038306-9aae5e071dd3?w=400',
  steps: [{
    id: 1,
    title: 'Comprar tênis de corrida',
    completed: true,
    completedDate: '05/01/2024'
  }, {
    id: 2,
    title: 'Correr 5km',
    completed: true,
    completedDate: '12/01/2024'
  }, {
    id: 3,
    title: 'Correr 10km',
    completed: false,
    completedDate: null
  }]
}, {
  id: 3,
  title: 'Economizar R$ 10.000',
  category: 'Finanças',
  status: 'completed',
  deadline: 'Mar 2024',
  progress: 100,
  image: 'https://images.unsplash.com/photo-1579621970563-ebec7560ff3e?w=400',
  steps: [{
    id: 1,
    title: 'Criar planilha de gastos',
    completed: true,
    completedDate: '01/01/2024'
  }, {
    id: 2,
    title: 'Economizar R$ 1000/mês',
    completed: true,
    completedDate: '31/03/2024'
  }]
}, {
  id: 4,
  title: 'Ler 24 livros este ano',
  category: 'Educação',
  status: 'in_progress',
  deadline: 'Dez 2024',
  progress: 50,
  image: 'https://images.unsplash.com/photo-1507842217343-583bb7270b66?w=400',
  steps: [{
    id: 1,
    title: 'Ler 2 livros por mês',
    completed: false,
    completedDate: null
  }]
}];
export function UserDetail() {
  const {
    id
  } = useParams();
  const [selectedDream, setSelectedDream] = useState<(typeof userDreams)[0] | null>(null);
  return <div className="space-y-6" data-id="element-507">
      <Link to="/users" className="inline-flex items-center gap-2 text-[#2C4A6B] hover:text-[#1E3A5F] font-medium" data-id="element-508">
        <ArrowLeft className="w-4 h-4" data-id="element-509" />
        Voltar para Usuários
      </Link>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-510">
        <div className="flex flex-col lg:flex-row items-start lg:items-start justify-between gap-4" data-id="element-511">
          <div className="flex items-start gap-6 w-full lg:w-auto" data-id="element-512">
            <div className="w-20 h-20 bg-gradient-to-br from-[#8BC4C3] to-[#2C4A6B] rounded-full flex items-center justify-center text-white text-2xl font-bold flex-shrink-0" data-id="element-513">
              A
            </div>
            <div className="flex-1" data-id="element-514">
              <h1 className="text-2xl font-bold text-gray-900" data-id="element-515">Ana Silva</h1>
              <div className="flex flex-col sm:flex-row sm:items-center gap-2 sm:gap-4 mt-2 text-sm text-gray-600" data-id="element-516">
                <div className="flex items-center gap-1" data-id="element-517">
                  <Mail className="w-4 h-4" data-id="element-518" />
                  ana.silva@email.com
                </div>
                <div className="flex items-center gap-1" data-id="element-519">
                  <Calendar className="w-4 h-4" data-id="element-520" />
                  Cadastrado em 15/01/2024
                </div>
              </div>
              <div className="flex gap-2 mt-3" data-id="element-521">
                <span className="px-3 py-1 text-xs font-medium bg-green-100 text-green-700 rounded-full" data-id="element-522">
                  Ativo
                </span>
                <span className="px-3 py-1 text-xs font-medium bg-gray-100 text-gray-700 rounded-full" data-id="element-523">
                  Método: Email
                </span>
              </div>
            </div>
          </div>
          <button className="flex items-center gap-2 px-4 py-2 text-red-600 border border-red-300 rounded-lg hover:bg-red-50 transition-colors w-full sm:w-auto justify-center lg:justify-start" data-id="element-524">
            <Trash2 className="w-4 h-4" data-id="element-525" />
            Excluir Usuário
          </button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-526">
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-527">
          <div className="flex items-start justify-between mb-3" data-id="element-528">
            <div className="flex-1" data-id="element-529">
              <p className="text-sm font-medium text-gray-600 mb-2" data-id="element-530">
                Total de Sonhos
              </p>
              <p className="text-3xl font-bold text-gray-900" data-id="element-531">12</p>
            </div>
            <div className="text-cyan-500" data-id="element-532">
              <Target className="w-8 h-8" data-id="element-533" />
            </div>
          </div>
          <div className="flex items-center gap-1 text-sm text-gray-600" data-id="element-534">
            <span data-id="element-535">Sonhos criados</span>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-536">
          <div className="flex items-start justify-between mb-3" data-id="element-537">
            <div className="flex-1" data-id="element-538">
              <p className="text-sm font-medium text-gray-600 mb-2" data-id="element-539">
                Sonhos Concluídos
              </p>
              <p className="text-3xl font-bold text-gray-900" data-id="element-540">3</p>
            </div>
            <div className="text-green-500" data-id="element-541">
              <CheckCircle2 className="w-8 h-8" data-id="element-542" />
            </div>
          </div>
          <div className="flex items-center gap-1 text-sm text-green-600" data-id="element-543">
            <span data-id="element-544">Sonhos finalizados</span>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-545">
          <div className="flex items-start justify-between mb-3" data-id="element-546">
            <div className="flex-1" data-id="element-547">
              <p className="text-sm font-medium text-gray-600 mb-2" data-id="element-548">
                Em Andamento
              </p>
              <p className="text-3xl font-bold text-gray-900" data-id="element-549">9</p>
            </div>
            <div className="text-blue-500" data-id="element-550">
              <Clock className="w-8 h-8" data-id="element-551" />
            </div>
          </div>
          <div className="flex items-center gap-1 text-sm text-gray-600" data-id="element-552">
            <span data-id="element-553">Sonhos ativos</span>
          </div>
        </div>
        <div className="bg-white rounded-xl shadow-sm border border-gray-200 p-6" data-id="element-554">
          <div className="flex items-start justify-between mb-3" data-id="element-555">
            <div className="flex-1" data-id="element-556">
              <p className="text-sm font-medium text-gray-600 mb-2" data-id="element-557">
                Total de Passos
              </p>
              <p className="text-3xl font-bold text-gray-900" data-id="element-558">48</p>
            </div>
            <div className="text-purple-500" data-id="element-559">
              <Target className="w-8 h-8" data-id="element-560" />
            </div>
          </div>
          <div className="flex items-center gap-1 text-sm text-gray-600" data-id="element-561">
            <span data-id="element-562">Passos criados</span>
          </div>
        </div>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-gray-200" data-id="element-563">
        <div className="p-6 border-b border-gray-200" data-id="element-564">
          <h2 className="text-xl font-bold text-gray-900" data-id="element-565">Sonhos do Usuário</h2>
        </div>
        <div className="p-6" data-id="element-566">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-4" data-id="element-567">
            {userDreams.map(dream => <div key={dream.id} className="bg-white border border-gray-200 rounded-lg overflow-hidden hover:border-[#8BC4C3] transition-colors cursor-pointer" onClick={() => setSelectedDream(dream)} data-id="element-568">
                <div className="flex gap-4 p-4" data-id="element-569">
                  <div className="w-40 h-40 flex-shrink-0 rounded-lg overflow-hidden bg-gray-100" data-id="element-570">
                    <img src={dream.image} alt={dream.title} className="w-full h-full object-cover" data-id="element-571" />
                  </div>
                  <div className="flex-1 flex flex-col" data-id="element-572">
                    <div className="flex-1" data-id="element-573">
                      <h3 className="font-semibold text-gray-900 text-lg mb-2" data-id="element-574">
                        {dream.title}
                      </h3>
                      <div className="flex items-center gap-1 text-sm text-gray-600 mb-2" data-id="element-575">
                        <MapPin className="w-4 h-4" data-id="element-576" />
                        <span data-id="element-577">{dream.category}</span>
                      </div>
                      <p className="text-sm text-gray-600 mb-3" data-id="element-578">
                        Prazo: {dream.deadline}
                      </p>
                      <div className="space-y-1 mb-3" data-id="element-579">
                        <div className="flex items-center justify-between text-xs text-gray-600" data-id="element-580">
                          <span data-id="element-581">Progresso</span>
                          <span className="font-medium" data-id="element-582">{dream.progress}%</span>
                        </div>
                        <div className="w-full bg-gray-200 rounded-full h-1.5" data-id="element-583">
                          <div className="bg-gradient-to-r from-[#8BC4C3] to-[#2C4A6B] h-1.5 rounded-full transition-all" style={{
                        width: `${dream.progress}%`
                      }} data-id="element-584" />
                        </div>
                      </div>
                    </div>
                    <button className="px-4 py-2 bg-[#8BC4C3] hover:bg-[#6BABA9] text-white text-sm font-medium rounded-lg transition-colors self-start" data-id="element-585">
                      Ver passos
                    </button>
                  </div>
                </div>
              </div>)}
          </div>
        </div>
      </div>
      {selectedDream && <DreamStepsModal isOpen={!!selectedDream} onClose={() => setSelectedDream(null)} dreamTitle={selectedDream.title} steps={selectedDream.steps} data-id="element-586" />}
    </div>;
}